import { render, staticRenderFns } from "./BlocksContainer.vue?vue&type=template&id=1e53418f&"
import script from "./BlocksContainer.vue?vue&type=script&lang=js&"
export * from "./BlocksContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports